import React, {useState} from 'react';
import Modal from './Modal';
import {ACHIEVEMENTS_LIST, ACHIEVEMENT_TIERS} from '@/utils/constants';

const AchievementsModal = ({
  isOpen, 
  onClose, 
  stats, 
  maxTile, 
  score, 
  unlockedAchievements
}) => {
  const [selectedTier, setSelectedTier] = useState('all');

  const gameState = {
    stats,
    maxTile,
    score,
    moves: stats.moves
  };

  const achievementsByTier = {
    all: ACHIEVEMENTS_LIST,
    beginner: ACHIEVEMENTS_LIST.filter(a => a.tier === 'beginner'),
    advanced: ACHIEVEMENTS_LIST.filter(a => a.tier === 'advanced'),
    master: ACHIEVEMENTS_LIST.filter(a => a.tier === 'master')
  };

  const currentAchievements = achievementsByTier[selectedTier];

  const unlockedCount = Object.keys(unlockedAchievements).length;
  const totalCount = ACHIEVEMENTS_LIST.length;
  const progress = Math.round((unlockedCount / totalCount) * 100);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="成就收藏">
      <div className="text-center mb-4">
        <div className="text-3xl font-black text-gray-700 mb-2">
          {unlockedCount} <span className="text-lg text-gray-400">/ {totalCount}</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
          <div 
            className="bg-gradient-to-r from-purple-400 via-pink-400 to-yellow-400 h-2 rounded-full transition-all duration-500"
            style={{width: `${progress}%`}}
          />
        </div>
      </div>

      <div className="flex gap-2 mb-4 overflow-x-auto scrollbar-hide pb-2">
        <FilterBtn 
          active={selectedTier === 'all'} 
          onClick={() => setSelectedTier('all')}
          label="全部"
          icon="📋"
        />
        {Object.entries(ACHIEVEMENT_TIERS).map(([tier, config]) => (
          <FilterBtn 
            key={tier}
            active={selectedTier === tier} 
            onClick={() => setSelectedTier(tier)}
            label={config.label}
            icon={config.icon}
          />
        ))}
      </div>

      <div className="grid grid-cols-2 gap-3">
        {currentAchievements.map((achievement) => {
          const unlocked = unlockedAchievements[achievement.id];
          const tierConfig = ACHIEVEMENT_TIERS[achievement.tier];

          return (
            <div 
              key={achievement.id}
              className={`p-3 rounded-2xl text-center relative overflow-hidden transition-all duration-300 border-2 ${
                unlocked 
                  ? 'bg-gradient-to-br from-yellow-50 to-orange-50 border-yellow-300 shadow-lg scale-105' 
                  : 'bg-white/60 border-gray-200 opacity-70'
              }`}
            >
              <div className={`absolute top-1 right-1 text-[8px] font-black px-1.5 py-0.5 rounded-full ${tierConfig.color}`}>
                {tierConfig.icon}
              </div>

              <div className={`text-4xl mb-2 transition-transform ${unlocked ? 'animate-bounce' : 'grayscale'}`}>
                {achievement.icon}
              </div>

              <div className="font-black text-sm text-gray-700 mb-1">
                {achievement.name}
              </div>

              <div className="text-[10px] text-gray-500 leading-tight">
                {achievement.description}
              </div>

              {unlocked && (
                <div className="mt-2 text-[10px] font-black text-green-500 bg-green-100 px-2 py-1 rounded-full inline-block">
                  ✓ 已達成
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div className="mt-4 text-center bg-purple-50 p-3 rounded-2xl border-2 border-purple-100">
        <p className="text-xs text-purple-600 font-bold">
          {unlockedCount === totalCount 
            ? '🎉 恭喜!您已解鎖所有成就!' 
            : `💪 還有 ${totalCount - unlockedCount} 個成就等待您挑戰!`}
        </p>
      </div>
    </Modal>
  );
};

const FilterBtn = ({active, onClick, label, icon}) => (
  <button
    onClick={onClick}
    className={`px-3 py-1.5 rounded-xl text-xs font-black transition-all whitespace-nowrap ${
      active 
        ? 'bg-gradient-to-r from-purple-400 to-pink-400 text-white shadow-md scale-105' 
        : 'bg-white/60 text-gray-600 hover:bg-white'
    }`}
  >
    {icon} {label}
  </button>
);

export default AchievementsModal;